import TableServiceMoveLineItemsModal from "pages/secure/facility/tableService/LineItemModals/TableServiceMoveLineItemsModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

export default connect(undefined, mapDispatchToProps)(TableServiceMoveLineItemsModal);
